import { render, staticRenderFns } from "./Typ.vue?vue&type=template&id=fa9bb164&"
import script from "./Typ.vue?vue&type=script&lang=js&"
export * from "./Typ.vue?vue&type=script&lang=js&"
import style0 from "./Typ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports